<div class="mb-4 gap-20px flex-direction-column">
  <header class="flex-direction-row justify-content-between align-items-center ps__header">
    <div class="flex-direction-row align-items-center gap-5px">
      <span class="ps__header-title"
            [class]="additionalCardBuyingStates.cardQty ? 'ps__header-title-grey' : ''">{{ 'My_Plan' | translate }}</span>
      @if (additionalCardBuyingStates.cardQty) {
        <mat-icon class="ps__header-title ps__header-title-grey d-flex align-items-center justify-content-center">
          chevron_right
        </mat-icon>
        <span class="ps__header-title ps__header-title-last">{{ 'subscription_plan_content.add_additional_cards' | translate }}</span>
      }
    </div>
    <div class="flex-direction-row gap-14px align-items-center">
      @if (isShowCancelButton()) {
        <button class="cancel-button-white" (click)="cancelSubscription()">
          <span class="cancel-text">{{ 'Cancel' | translate }}</span>
        </button>
      }
      <div class="toggle-container">
        <button class="toggle-button" [class.active]="isMyPlanActive" (click)="togglePlan(true)">
          <span>{{ 'My_Plan' | translate }}</span>
        </button>
        <button class="toggle-button" [class.active]="!isMyPlanActive" (click)="togglePlan(false)">
          <span>{{ 'All_Subscriptions' | translate }}</span>
        </button>
      </div>
    </div>
  </header>
  <div [ngClass]="{'fixed-hug-container': isShowAllSubscriptions}">
    <section class="w-100 d-flex justify-content-between custom-row ms-2">
      <div class="toggle-container">
        <button class="toggle-button gap-12px" [class.active]="isIndividualActive" (click)="toggleIndividual(true)">
          <img src="assets/svg/person.svg" alt="">
          <span>{{ 'Individuals' | translate }}</span>
        </button>
        @if (activeTeamSubscriptionPlan || isShowAllSubscriptions) {
          <button class="toggle-button gap-12px w-100" [class.active]="!isIndividualActive" (click)="toggleIndividual(false)">
            <img src="assets/svg/group.svg" alt="">
            <span>{{ 'Teams' | translate }}</span>
          </button>
        }
      </div>
      @if (isShowAllSubscriptions) {
        <div class="col-11 col-lg-7 col-md-10 col-sm-9 d-flex justify-content-end">
          <app-toggle  [inputId]="'subscription-time-toggle'"
                       [data]="ToggleElModel.create({id: 1, leftText:'subscription_plan_content.monthly' | translate, rightText:'subscription_plan_content.yearly' | translate, additionalRightText:'subscription_plan_content.save_for' | translate})"
                       (onChange)="toggleTerm($event)"></app-toggle>
        </div>
      }
    </section>
    <br>
    @if (isSubscriptionCanceledInfoActive()) {
              <div class="subscription-cancel-information">
          <div class="text-and-icon-container">
            <img src="assets/svg/info-blue-icon.svg">
            <span class="info-text">{{ 'subscription_plan_content.subscription_cancelled_info' | translate }}</span>
          </div>
        </div>
    }
    <div class="d-flex flex-direction-column" *ngIf="isShowAllSubscriptions; else toggleSection">
      <div class="row subscription-plan-cards-container custom-margins mt-3 justify-content-between">
        @if (isIndividuals) {
          @for (individualsSubscriptionPlan of subscriptionIndividualsPlanInfoModel; track individualsSubscriptionPlan) {
            <div class="col-12 col-lg-4 col-md-8 col-sm-8 mt-3 custom-col">
            <app-subscription-plan-card  [isFromUserPage]="true"
                                        [activeSubscriptionPlanId]="getActiveSubscriptionPlanId('individual')"
                                        [activeTeamSubscriptionPlanId]="getActiveSubscriptionPlanId('team')"
                                        [isDisabledByMissingPayment]="isSubscriptionPlanDisabledByMissingPayment(individualsSubscriptionPlan.subscriptionPlanData.id)"
                                        [subscriptionPlanInfoModel]="individualsSubscriptionPlan"></app-subscription-plan-card>
            </div>
          }
        } @else {
          @for (teamsSubscriptionPlan of subscriptionTeamsPlanInfoModel; track teamsSubscriptionPlan) {
            <div class="col-12 col-lg-4 col-md-8 col-sm-8 mt-3 custom-col">
            <app-subscription-plan-card [isFromUserPage]="true"
                                        [activeSubscriptionPlanId]="getActiveSubscriptionPlanId('individual')"
                                        [activeTeamSubscriptionPlanId]="getActiveSubscriptionPlanId('team')"
                                        [isDisabledByMissingPayment]="isSubscriptionPlanDisabledByMissingPayment(teamsSubscriptionPlan.subscriptionPlanData.id)"
                                        [subscriptionPlanInfoModel]="teamsSubscriptionPlan"></app-subscription-plan-card>
            </div>
          }
        }
      </div>
    </div>
  </div>
  <ng-template #toggleSection>
  <main class="mt-4 w-100 flex-direction-row gap-20px ps__main">

    <section class="ps__main-left">

              @if (!isIndividualActive) {
        @if (additionalCardBuyingStates.default) {
          <div class="ps__main-additional-cards ps__main-div ps__ac__flex-direction-row-buttons">
            <span class="ps__main-additional-title">{{ 'subscription_plan_content.additional_cards' | translate }}</span>
            <button class="short-button outlined-button" (click)="setAdditionalCardBuyingStates('cardQty')">{{ 'subscription_plan_content.add_card' | translate }}
            </button>
          </div>
        } @else if (additionalCardBuyingStates.cardQty) {
          <div class="ps__main-additional-cards-card-qty ps__main-div">
            <div class="ps__main-additional-cards-price-container">
              <span class="ps__main-additional-cards-price">{{ roundPrice(calculateTotalPrice()) }}$</span>
              <span class="ps__main-additional-cards-price-description">{{ 'subscription_plan_content.to_pay' | translate }}</span>
            </div>

            <div class="ps__main-additional-cards-card-qty-body">
              <span class="ps__main-additional-info-text">
                <img src="assets/svg/info.svg" alt="" matTooltipPosition="above"
                     [matTooltip] = "activeSubscriptionTitle + ': Additional card qty is '
                      + activeSubscriptionAdditionalCardsCount">
              </span>
              <app-filled-form-field
                class="width-100 card-qty-form-field-default"
                [ngClass]="!isCardQtyInvalid() ? 'card-qty-form-field' : 'card-qty-form-field-invalid'"
                label="{{ 'subscription_plan_content.card_qty' | translate }}"
                [isOnlyNumber]="true"
                [minNumber]="1"
                [maxNumberLength]="additionalCardsLength"
                [isControlInvalid]="isCardQtyInvalid()"
                [errorMessage]="purchaseAdditionalCardsErrorMessage"
                [formControl]="cardQty"
              >
              </app-filled-form-field>
              <div class="ps__main-additional-cards-info-container">
                <div>
                  <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.additional_card_qty' | translate }}</span>
                  <span
                    class="ps__main-additional-cards-info">{{ cardQty.getRawValue() ? cardQty.getRawValue() : 0 }}</span>
                </div>
                <div>
                  <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.price_one_card_per_month' | translate }}</span>
                  <span
                    class="ps__main-additional-cards-info">${{ activeSubscriptionPlan.subscriptionInfoResponse.nextCardPrice }}</span>
                </div>
                <div>
                  <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.total_additional_cards_price' | translate }}</span>
                  <span class="ps__main-additional-cards-info">${{ roundPrice(calculateTotalPrice()) }}</span>
                </div>
              </div>
            </div>

            <div class="w-100 flex-direction-row justify-content-end gap-10px ps__flex-direction-row-buttons">
              <button class="short-button text-button" (click)="setAdditionalCardBuyingStates('default')">{{ 'subscription_plan_content.cancel' | translate }}
              </button>
              <button class="short-button filled-button"
                      [disabled]="isCardQtyInvalid() || cardQty.getRawValue()?.length == 0"
                      (click)="buyAdditionalCards()">{{ 'subscription_plan_content.pay' | translate }}
              </button>
            </div>
          </div>
        } @else if (additionalCardBuyingStates.addCard) {
          <div class="ps__main-div gap-24px">
            <div class="flex-direction-column gap-14px">
              <div class="flex-direction-row justify-content-between gap-10px">
                <span class="ps__main-additional-title">{{ 'subscription_plan_content.additional_cards' | translate }}</span>

                <div class="flex-direction-row gap-20px duration-container-parent">
                  <div class="flex-direction-column duration-container">
                    <span class="duration-title">{{ 'subscription_plan_content.starts' | translate }}</span>
                    <span class="duration-date">{{ activeSubscriptionPlan.startDate | date:'dd/MM/yyyy' }}</span>
                  </div>
                  <div class="flex-direction-column duration-container">
                    <span class="duration-title">{{ 'subscription_plan_content.ends' | translate }}</span>
                    <span class="duration-date">{{ activeSubscriptionPlan.endDate | date:'dd/MM/yyyy' }}</span>
                  </div>
                </div>
              </div>

              <div class="flex-direction-column gap-10px">
                <div class="ps__main-additional-cards-info-container ps__main-additional-cards-total-container">
                  <div>
                    <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.additional_card_qty' | translate }}</span>
                    <span
                      class="ps__main-additional-cards-info">{{ activeAdditionalSubscriptionPlan.subscriptionInfoResponse.cardCount }}</span>
                  </div>
                  <div>
                    <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.price_one_card_per_month' | translate }}</span>
                    <span
                      class="ps__main-additional-cards-info">${{ activeSubscriptionPlan.subscriptionInfoResponse.nextCardPrice }}</span>
                  </div>
                  <div>
                    <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.total_additional_cards_price' | translate }}</span>
                    <span
                      class="ps__main-additional-cards-info ps__total-additional-price">${{ roundPrice(getAdditionalCardsPrice()) }}</span>
                  </div>
                </div>
                <div class="ps__main-additional-cards-info-container ps__main-additional-cards-total-container">
                  <div>
                    <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.total_price' | translate }}</span>
                    <span
                      class="ps__main-additional-cards-info ps__total-price">{{ roundPrice(getAdditionalCardsAndSubscriptionPrice()) }}
                      $</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-100 flex-direction-row justify-content-end gap-10px ps__flex-direction-row-buttons">
              <button class="bb-style short-button text-button" [disabled]="!additionalCards.length" (click)="openMoveOrRemoveDialog()">{{ 'subscription_plan_content.move_or_remove' | translate }}</button>
              <button class="short-button filled-button" (click)="setAdditionalCardBuyingStates('addAdditional')">{{ 'subscription_plan_content.add_card' | translate }}
              </button>
            </div>
          </div>
        } @else if (additionalCardBuyingStates.addAdditional) {
          <div class="ps__main-additional-cards-card-qty ps__main-div">
            <div class="ps__main-additional-cards-price-container">
              <span class="ps__main-additional-cards-price">{{ roundPrice(calculateTotalPrice()) }}$</span>
              <span class="ps__main-additional-cards-price-description">{{ 'subscription_plan_content.to_pay' | translate }}</span>
            </div>

            <div class="ps__main-additional-cards-card-qty-body">
                <span class="ps__main-additional-info-text">
                  <img src="assets/svg/info.svg" alt="Info" matTooltip="{{ 'subscription_plan_content.add_more_cards_info' | translate }}">
                </span>
              <app-filled-form-field
                class="width-100 card-qty-form-field-default"
                [ngClass]="!isAddAdditionalCardQtyInvalid() ? 'card-qty-form-field' : 'card-qty-form-field-invalid'"
                label="{{ 'subscription_plan_content.card_qty' | translate }}"
                [isOnlyNumber]="true"
                [minNumber]="1"
                [maxNumberLength]="additionalCardsLength"
                [isControlInvalid]="isAddAdditionalCardQtyInvalid()"
                [errorMessage]="addAdditionalCardsErrorMessage"
                [formControl]="cardQty"
              >
              </app-filled-form-field>
              <div class="ps__main-additional-cards-info-container">
                <div>
                  <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.additional_card_qty' | translate }}</span>
                  <span
                    class="ps__main-additional-cards-info">{{ cardQty.getRawValue() ? cardQty.getRawValue() : 0 }}</span>
                </div>
                <div>
                  <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.price_one_card_per_month' | translate }}</span>
                  <span
                    class="ps__main-additional-cards-info">${{ activeAdditionalSubscriptionPlan.subscriptionInfoResponse.nextCardPrice }}</span>
                </div>
                <div>
                  <span class="ps__main-additional-cards-info-title">{{ 'subscription_plan_content.total_additional_cards_price' | translate }}</span>
                  <span class="ps__main-additional-cards-info">${{ roundPrice(calculateTotalPrice()) }}</span>
                </div>
              </div>
            </div>

            <div class="w-100 flex-direction-row justify-content-end gap-10px ps__flex-direction-row-buttons">
              <button class="short-button text-button" (click)="setAdditionalCardBuyingStates('addCard')">{{ 'subscription_plan_content.cancel' | translate }}
              </button>
              <button class="short-button filled-button"
                      [disabled]="isCardQtyInvalid() || cardQty.getRawValue()?.length == 0"
                      (click)="addAdditionalCards()">{{ 'subscription_plan_content.pay' | translate }}
              </button>
            </div>
          </div>
        }
      }

      <div class="ps__main-div">
        <span class="ps__main-title">{{ 'subscription_plan_content.history' | translate }}</span>

        <div class="invoice-history__table-wrap">
          <table class="invoice-history__table">
            <thead>
            <tr>
              <th>{{ 'subscription_plan_content.start_date' | translate }}</th>
              <th>{{ 'subscription_plan_content.end_date' | translate }}</th>
              <th>{{ 'subscription_plan_content.subscription_name' | translate }}</th>
              <th>{{ 'subscription_plan_content.pdf' | translate }}</th>
            </tr>
            </thead>
            <tbody>
              @for (invoice of visibleInvoiceHistory; track invoice) {
                <tr>
                  <td>{{ invoice.subscription.startDate  | date:'dd/MM/yyyy' }}</td>
                  <td>{{ invoice.subscription.endDate | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ getTranslatedSubscriptionTitle(invoice.subscription.subscriptionInfoResponse.subscriptionType) }}</td>
                  <td>
                    <div class="download-button" (click)="download(invoice.subscription.id)">
                      <img src="assets/svg/download.svg" alt="">
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (canShowViewMoreHistory || canShowViewLessHistory) {
          <div class="d-flex justify-content-end gap-10px mt-1">
            @if (canShowViewMoreHistory) {
              <button class="short-button text-button history-toggle-button" (click)="viewMoreHistory()">{{ 'rating.more' | translate }}</button>
            }
            @if (canShowViewLessHistory) {
              <button class="short-button text-button history-toggle-button" (click)="viewLessHistory()">{{ 'rating.less' | translate }}</button>
            }
          </div>
        }
      </div>

    </section>

    <section class="ps__main-right">
      <div class="ps__main-div">
        <ng-container [ngTemplateOutlet]="subscriptionPlanCardTemplate"></ng-container>
      </div>

      <div class="ps__main-div">
        <div class="card-list-top-container">
          <span class="ps__main-title">{{ 'subscription_plan_content.payment' | translate }}</span>
          <button class="filled-button short-button" (click)="pairCreditCard()">{{ 'subscription_plan_content.add_new_card' | translate }}</button>
        </div>

        @for (card of creditCards; track card) {
          <div class="position-relative">
            <app-credit-card-select [creditCardLast4Numbers]="card.cardNumber" [isSelected]="card.isActive"
                                    (selected)="selectCreditCard(card)"></app-credit-card-select>

            <div class="delete-content-edit delete-content-icon"
                 [ngClass]="(!card.isActive && creditCards.length > 1) ? 'd-block me-2' : 'd-none'" (click)="openConfirmRemovingDialog(card)">
              <button class="delete-icon-button">
                <img src="assets/svg/close-icon.svg">
              </button>
            </div>
          </div>
        }
      </div>

    </section>

  </main>
  </ng-template>
</div>

<ng-template #subscriptionPlanCardTemplate>
  @if (activeSubscriptionPlan) {
    <div class="standard-card-container ml-40px my-subscriptions-subscription-plan">
      <div class="standard-card">
        <div class="first-standard-card-layout">
          <div class="standard-card-icon-and-text-container">
            <div [ngClass]="{'standard-card-icon-container-active': activeSubscriptionPlan.isStandard,  'standard-card-icon-container': !activeSubscriptionPlan.isStandard }">
              <img [src]="
        activeSubscriptionPlan.subscriptionInfoResponse?.subscriptionType?.toLowerCase() === 'basic' ? 'assets/subscription-plan/icon-starter.svg' :
        activeSubscriptionPlan.subscriptionInfoResponse?.subscriptionType?.toLowerCase() === 'professional' ? 'assets/subscription-plan/icon-standard.svg' :
        activeSubscriptionPlan.subscriptionInfoResponse?.subscriptionType?.toLowerCase() === 'unlim' ? 'assets/subscription-plan/icon-premium.svg' :
        activeSubscriptionPlan.isStarter ? 'assets/subscription-plan/icon-starter.svg' :
        activeSubscriptionPlan.isStandard ? 'assets/subscription-plan/icon-standard.svg' :
        'assets/subscription-plan/icon-premium.svg'" class="standard-icon" alt="icon">
            </div>
            <div class="standard-text" [attr.lang]="(currentLang$ | async) ?? ''">
              {{ getTranslatedSubscriptionTitle(activeSubscriptionPlan.subscriptionInfoResponse.subscriptionType) }}
            </div>
          </div>
          <br>
          <div class="standard-under-text">
            {{ activeSubscriptionPlan.subscriptionInfoResponse.description | translate }}
          </div>
          <br>


      <div class="standard-card-cost-container" [ngClass]="{'discounted-price-container': isActivatedPromoCode}">
        <div class="text-decoration-line-through"></div>
          <div class="sp__card-cost"
            [ngClass]="{'my-standard-card-cost-active' : activeSubscriptionPlan.isStandard, 'my-standard-card-cost' : !activeSubscriptionPlan.isStandard,  'my-standard-card-cost-ru': currentLang === Language.RU, 'my-standard-card-cost-am': currentLang === Language.HY }">
            @if (activeSubscriptionPlan.subscriptionInfoResponse.price === 0) {
            {{ FREE | translate }}
            } @else if (activeSubscriptionPlan.isYearly) {
            ${{ activeSubscriptionPlan.subscriptionInfoResponse.price * 10 }}
            } @else {
            ${{ activeSubscriptionPlan.subscriptionInfoResponse.price }}
            }
          </div>
        @if (activeSubscriptionPlan.subscriptionInfoResponse.price !== 0) {
          <div class="subscribe-duration">
              @if (activeSubscriptionPlan.isYearly) {
                {{ activeSubscriptionPlan.subscriptionInfoResponse.price * 10 * SharedConstants.DOLLAR_EXCHANGE_RATE }} {{SharedConstants.AMD_CURRENCY}}
              } @else {
                {{ activeSubscriptionPlan.subscriptionInfoResponse.price * SharedConstants.DOLLAR_EXCHANGE_RATE }} {{SharedConstants.AMD_CURRENCY}} }
          </div>
        }
        <div class="subscribe-duration-slash">/</div>
        <div class="subscribe-duration">
          @if (!activeSubscriptionPlan.isYearly) {
            {{ 'subscription_plan_content.monthly' | translate }}
          } @else {
            {{ 'subscription_plan_content.yearly' | translate }}
          }
        </div>
      </div>

      @if (isActivatedPromoCode) {
        <div class="standard-card-cost-container">
          <div class="sp__card-cost"
               [ngClass]="{'my-standard-card-cost-active' : activeSubscriptionPlan.isStandard, 'my-standard-card-cost' : !activeSubscriptionPlan.isStandard,  'my-standard-card-cost-ru': currentLang === Language.RU, 'my-standard-card-cost-am': currentLang === Language.HY }">
            @if (activeSubscriptionPlan.isYearly) {
              ${{ getDiscountedPrice * 10 }}
            } @else {
              ${{ getDiscountedPrice }}
            }
          </div>
          @if (getDiscountedPrice !== 0) {
            <div class="subscribe-duration">
              @if (activeSubscriptionPlan.isYearly) {
                {{ getDiscountedPrice * 10 * SharedConstants.DOLLAR_EXCHANGE_RATE }} {{SharedConstants.AMD_CURRENCY}}
              } @else {
                {{ getDiscountedPrice * SharedConstants.DOLLAR_EXCHANGE_RATE }} {{SharedConstants.AMD_CURRENCY}}
              }
            </div>
          }
          <div class="subscribe-duration-slash">/</div>
          <div class="subscribe-duration">
            @if (!activeSubscriptionPlan.isYearly) {
              {{ 'Monthly' }}
            } @else {
              {{ 'Yearly' }}
            }
          </div>
        </div>
      }

          <br>

          <div [ngClass]="activeSubscriptionPlan.isStarter ? 'sub-plan-duration-starter' : 'sub-plan-duration'">
            <div>
              <span class="duration-title">{{ 'subscription_plan_content.starts' | translate }}</span>
              <span class="duration-date">{{ activeSubscriptionPlan.startDate | date:'dd/MM/yyyy' }}</span>
            </div>

            @if (!activeSubscriptionPlan.isStarter) {
              <div>
                <span class="duration-title">{{ 'subscription_plan_content.ends' | translate }}</span>
                <span class="duration-date">{{ activeSubscriptionPlan.endDate | date:'dd/MM/yyyy' }}</span>
              </div>
            }
          </div>

          <br class="sub-plan-duration-br">
          <div class="subscription-plan-include-container">
            <div class="subscription-plan-include-text" [attr.lang]="currentLang">
              {{ 'subscription_plan_content.whats_included' | translate }}
            </div>
            <div class="subscription-plan-included">
              <div class="plan-include-container">
                <div class="plan-include-icon">
                  <img src="/assets/subscription-plan/check-circle-Icon.svg" alt="check-circle-icon">
                </div>
                <div class="plan-include-text">
                  @if (activeSubscriptionPlan.subscriptionInfoResponse.parent.accountType === AccountType.INDIVIDUAL) {
                    @if (activeSubscriptionPlan.subscriptionInfoResponse.cardCount > 1) {
                      {{ activeSubscriptionPlan.subscriptionInfoResponse.cardCount }}
                      {{ 'subscription_plan_content.free_cards' | translate }}
                    } @else {
                      {{ activeSubscriptionPlan.subscriptionInfoResponse.cardCount }}
                      {{ 'subscription_plan_content.free_card' | translate }}
                    }
                  } @else if (activeSubscriptionPlan.subscriptionInfoResponse.parent.accountType === AccountType.TEAM) {
                    {{ 'subscription_plan_content.up_to' | translate }}
                    {{ activeSubscriptionPlan.subscriptionInfoResponse.cardCount }}
                    {{ 'subscription_plan_content.member_cards' | translate }}
                  }
                </div>
              </div>
              @if (activeSubscriptionPlan.subscriptionInfoResponse.parent.accountType === AccountType.TEAM) {
                <div class="plan-include-container">
                  <div class="plan-include-icon">
                    <img src="/assets/subscription-plan/check-circle-Icon.svg" alt="check-circle-icon">
                  </div>
                  <div class="plan-include-text">
                    @if (activeSubscriptionPlan.isYearly) {
                      {{ 'subscription_plan_content.next_card_price_is' | translate }}
                      {{ activeSubscriptionPlan.subscriptionInfoResponse.nextCardPrice * 10 }}$
                    } @else {
                      {{ 'subscription_plan_content.next_card_price_is' | translate }}
                      {{ activeSubscriptionPlan.subscriptionInfoResponse.nextCardPrice }}$
                    }
                  </div>
                </div>
              }
              <div class="plan-include-container">
                <div class="plan-include-icon">
                  <img src="/assets/subscription-plan/check-circle-Icon.svg" alt="check-circle-icon">
                </div>
                <div class="plan-include-text">
                  @if (activeSubscriptionPlan.subscriptionInfoResponse.linkCount === null) {
                    {{ 'subscription_plan_content.unlimited_links' | translate }}
                  } @else {
                    {{ 'subscription_plan_content.up_to' | translate }}
                    {{ activeSubscriptionPlan.subscriptionInfoResponse.linkCount }}
                    {{ 'subscription_plan_content.links' | translate }}
                  }
                </div>
              </div>
              @if (activeSubscriptionPlan.subscriptionInfoResponse.subscriptionType !== SubscriptionType.STARTER) {
                <div class="plan-include-container">
                  <div class="plan-include-icon">
                    <img src="/assets/subscription-plan/check-circle-Icon.svg" alt="check-circle-icon">
                  </div>
                  <div class="plan-include-text">
                    @if (activeSubscriptionPlan.subscriptionInfoResponse.paymentMethodCount === null) {
                      {{ 'subscription_plan_content.all_payment_methods' | translate }}
                    } @else {
                      {{ activeSubscriptionPlan.subscriptionInfoResponse.paymentMethodCount }}
                      {{ 'subscription_plan_content.payment_method' | translate }}
                    }
                  </div>
                </div>
              }
              @if (activeSubscriptionPlan.subscriptionInfoResponse.subscriptionType === SubscriptionType.PREMIUM &&
                   activeSubscriptionPlan.subscriptionInfoResponse.parent.accountType === AccountType.INDIVIDUAL) {
                <div class="plan-include-container">
                  <div class="plan-include-icon">
                    <img src="/assets/subscription-plan/check-circle-Icon.svg" alt="check-circle-icon">
                  </div>
                  <div class="plan-include-text">
                    {{ 'subscription_plan_content.menu_management' | translate }}
                  </div>
                </div>
              }
            </div>
          </div>

        </div>
      </div>
    </div>
  }
</ng-template>
